const accordionAll = document.querySelectorAll(".accordion");

if (accordionAll) {
  accordionAll.forEach((accordion) => {
    const accordionItems = accordion.querySelectorAll(".accordion-item");
    const accordionImage = accordion.querySelector(".services-graphic");

    // Toggle accordion items on click
    accordionItems.forEach((item) => {
      item.addEventListener("click", (ev) => {
        const activeItem = accordion.querySelector(".active");

        item.classList.toggle("active");
        if (activeItem) {
          activeItem.classList.remove("active");
        }
        setTimeout(() => {
          document.getElementById(ev.target.id).scrollIntoView();
        }, 250);
      });
    });

    // Toggle accordion items based on image
    if (accordionImage) {
      const accordionImageLinks = accordionImage.querySelectorAll("a");
      // console.log(accordionImageLinks);
      accordionImageLinks.forEach((link) => {
        link.addEventListener("click", (ev) => {
          ev.preventDefault();
          const target = accordion.querySelector(link.getAttribute("xlink:href"));
          // target.scrollIntoView();
          target.click();
          // document.getElementById(ev.target.id).scrollIntoView();
        });
      });
    }
  });
}
